export const TIPOS = [
  'Corrigir',
  'Criar',
  'Modificar'
] as const;

export const PRIORIDADES = [
  {
    valor: '🧇🧇🧇🧇🧇',
    descricao: 'Crítico: Sistema parado/bloqueado'
  },
  {
    valor: '🧇🧇🧇🧇',
    descricao: 'Urgente: Impacto significativo no trabalho'
  },
  {
    valor: '🧇🧇🧇',
    descricao: 'Alta: Afeta produtividade, mas tem workaround'
  },
  {
    valor: '🧇🧇',
    descricao: 'Média: Pode esperar alguns dias'
  },
  {
    valor: '🧇',
    descricao: 'Baixa: Melhoria/sugestão'
  }
] as const;

export const AREAS_QTRO = [
  'Qualidade',
  'Tração',
  'Receita',
  'Organização'
] as const;

export const STATUS = [
  'Pendente',
  'Respondido',
  'Resolvido'
] as const; 